import { substitutionSchema } from "@superwall-me/schema";
import { z } from "zod";
const subsitutionsSchema = z.object({
    substitutions: z.array(substitutionSchema)
});
const paywallMiddleware = (db)=>{
    db.$use(async (params, next)=>{
        if (params.model === "Paywall" && [
            "create",
            "update"
        ].includes(params.action)) {
            if (params.args && params.args.data && params.args.data.substitutions) {
                const parseResult = subsitutionsSchema.safeParse(params.args.data.substitutions);
                if (!parseResult.success) {
                    if (params.action === "create") {
                        params.args.data.substitutions = {
                            substitutions: []
                        };
                    }
                    params.args.data.substitutions = undefined;
                } else {
                    params.args.data.substitutions = parseResult.data;
                }
            }
        }
        const result = await next(params);
        // Transform  [] -> { substitutions: [] }
        if (params.model === "Paywall" && result && result.substitutions && Array.isArray(result.substitutions)) {
            result.substitutions = {
                substitutions: []
            };
        }
        return result;
    });
};
export default paywallMiddleware;
